import MuiTablePagination from "@mui/material/TablePagination";

const ROWS_PER_PAGE_OPTIONS = [10, 25, 100, 200];

export default function TablePagination({
    totalCount = 0,
    page = 0,
    rowsPerPage = 25,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS,
}) {
    if (Number(totalCount || 0) <= 10) {
        return null;
    }

    const handleRowsPerPageChange = (event) => {
        onRowsPerPageChange?.(Number(event.target.value));
    };

    return (
        <MuiTablePagination
            component="div"
            count={Number(totalCount || 0)}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={(event, nextPage) => onPageChange?.(nextPage)}
            onRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageOptions={rowsPerPageOptions}
            labelRowsPerPage="Rows per page"
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                borderTop: "1px solid rgba(148,163,184,0.16)",
                px: { xs: 0, sm: 1 },
                "& .MuiTablePagination-toolbar": {
                    justifyContent: "flex-end",
                    gap: { xs: 0.5, sm: 1 },
                    px: { xs: 1, sm: 2 },
                    py: { xs: 0.75, sm: 0 },
                    minHeight: { xs: 48, sm: 54 },
                    flexWrap: { xs: "wrap", sm: "nowrap" },
                },
                "& .MuiTablePagination-spacer": {
                    display: "none",
                },
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                    fontWeight: 700,
                    color: "text.secondary",
                    m: 0,
                    fontSize: { xs: "0.78rem", sm: "0.875rem" },
                },
                "& .MuiTablePagination-actions": {
                    ml: { xs: 0, sm: 1 },
                },
            }}
        />
    );
}
